/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */

export const AgentInstanceBindingTypename = 'com.hubspot.automation.templatesrpc.models.AgentInstanceBinding';
export const AgentInstanceBindingDiscriminant = 'AGENT_INSTANCE';
export const AgentInstanceBindingDiscriminantKey = 'type';
/**
 *  Binds every Run Agent action the template leaves open (those without an agent specified in
 *  the template's agent manifest) to an existing agent instance.
 */

export const AssetBindingDiscriminantKey = 'type';

/**
 *  What instantiation did with one {@link AssetBinding}. {@code reason} and {@code message} are
 *  present only when {@code status} is {@code NOT_APPLIED}.
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const instantiateTemplateRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'instantiateTemplate',
  auth: 'app',
  fingerprint: 'LwOCaXz8iL6pn7CVh1dwUN0LIIxqXL4B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstantiationStatusRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'getInstantiationStatus',
  auth: 'app',
  fingerprint: 'QIJe6dqwsi1asdzO-RnSldrKPlNJ01-G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listInstantiationRequestsRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'listInstantiationRequests',
  auth: 'app',
  fingerprint: 'sY2kt8fWxgqUN4AGQY94CpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listWorkflowsForTemplateRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'listWorkflowsForTemplate',
  auth: 'app',
  fingerprint: 'B4OkBkjdj5J1ZtOmbv1J5ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};